import { Component, inject, output } from '@angular/core';
import { QrGenerationComponent } from '../qr-generation/qr-generation.component';
import { QRCodeConfig } from '@zayan-erp/sales';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-qr-code-dialog',
  standalone: true,
  imports: [QrGenerationComponent],
  templateUrl: './qr-code-dialog.component.html',
  styleUrl: './qr-code-dialog.component.scss'
})
export class QrCodeDialogComponent {
  config!: QRCodeConfig;
  qrGenerated = output<boolean>();
  qrError = output<string>();

  #activeModal = inject(NgbActiveModal);

  onQrGenerated(success: boolean) {
    this.qrGenerated.emit(success);
  }

  onQrError(error: string) {
    this.qrError.emit(error);
  }

  closeDialog() {
    this.#activeModal.close();
  }
}
